import { render, staticRenderFns } from "./DateField.vue?vue&type=template&id=33f5484b&scoped=true&"
import script from "./DateField.vue?vue&type=script&lang=js&"
export * from "./DateField.vue?vue&type=script&lang=js&"
import style0 from "./DateField.vue?vue&type=style&index=0&id=33f5484b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f5484b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDatePicker,VIcon,VMenu,VTextField})
